type CurrencyFormatOptions = Pick<
  Intl.NumberFormatOptions,
  'minimumFractionDigits' | 'maximumFractionDigits'
>

/**
 * Keep locale digits, grouping and bidi marks. The new U+20C1 sign is not yet
 * supported by every customer font, so SAR uses a readable currency label.
 */
export function formatCurrency(
  cents: number,
  currency: string,
  locale: string,
  options: CurrencyFormatOptions = {},
) {
  const normalizedCurrency = currency.trim().toUpperCase()
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: normalizedCurrency,
    ...options,
  })

  return formatter.formatToParts(cents / 100).map((part) => {
    if (part.type === 'currency' && normalizedCurrency === 'SAR') return currencySymbol('SAR', locale)
    return part.value
  }).join('')
}

export function currencySymbol(currency: string, locale: string) {
  const normalizedCurrency = currency.trim().toUpperCase()
  if (normalizedCurrency === 'SAR') return locale.toLowerCase().startsWith('ar') ? 'ر.س.' : 'SAR'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: normalizedCurrency,
    currencyDisplay: 'narrowSymbol',
  }).formatToParts(0).find((part) => part.type === 'currency')?.value ?? normalizedCurrency
}
